import "./polyfills.js";
import "./buttons.js";
import "./dialogs.js";
import "./embededs.js";
import "./external-links.js";
// import "./images.js";

import "../modules/media-text/hero/index.js";
import "../modules/article/default/index.js";
import "../modules/query/default/index.js";
import "../modules/header/default/index.js";